import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'jalali-moment';
import { CalculatorService } from '../../services/calculator.service';
import { AvailableFundsComponent } from '../../components/available-funds/available-funds.component';
import { CalculatedInfoCardComponent } from '../../components/calculated-info-card/calculated-info-card.component';
import { takeUntil } from 'rxjs';

import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { CalculatorEfficiencies } from '../../../../data-access/models/calculator-efficiencies.model';
import { HOME_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';

@Component({
  selector: 'app-calculator-profit',
  templateUrl: './calculator-profit.component.html',
  styleUrls: ['./calculator-profit.component.scss'],
  standalone: true,
  imports: [AvailableFundsComponent, CalculatedInfoCardComponent, NgxAppBarComponent],
})
export class CalculatorProfitComponent extends BaseComponent implements OnInit {
  cardInfo = { fromDate: '0', toDate: '0', amount: '0' };
  funds!: CalculatorEfficiencies[];
  navigationService = inject(WealthNavigationService);

  constructor(
    private route: ActivatedRoute,
    private calcService: CalculatorService,
  ) {
    super();
    const params = this.route.snapshot.queryParams;
    const fromDate = moment(+params['from']).locale('en').format('YYYY-MM-DD');
    const toDate = moment(+params['to']).locale('en').format('YYYY-MM-DD');
    this.cardInfo = {
      fromDate,
      toDate,
      amount: params['amount'],
    };

    this.calcService
      .getFunds({
        fromDate,
        toDate,
        amount: params['amount'],
      })
      .pipe(takeUntil(this.destroyObservable))
      .subscribe((res: CalculatorEfficiencies[]) => {
        this.funds = res;
      });
  }

  ngOnInit(): void {}

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }
}
